import { RecordMessageC, Type } from '@/scripts/types/sockets/record';
import { useSidebarStore } from '@/vue/stores/sidebar';
import { ReportMessageC } from '../../../scripts/types/sockets/report';
import { ScheduleMessageC } from '../../../scripts/types/sockets/schedule';
import { Channel, useTypedSocket } from '../../composables/socket';

type Props = {
    hideSidebar(): void,
}

type EntityMessage = {
    id: string|number;
    type: string;
}

export const useSidebarSocketLogic = ({
    hideSidebar,
}: Props) => {
    const sidebarStore = useSidebarStore();
    const handleSocketMessage = (
        entityType: string, { id: entityId, type }: EntityMessage,
    ) => {
        if (
            sidebarStore.entityId !== entityId
            || type !== 'delete'
            || sidebarStore.entityType !== entityType
            || sidebarStore.isSaving
        ) {
            return;
        }

        hideSidebar();
    };

    useTypedSocket(Channel.RECORD, RecordMessageC, (message) => {
        if (message.type === Type.DELETE) {
            handleSocketMessage('record', message);
        }
    });
    useTypedSocket(Channel.REPORT, ReportMessageC, (message) => handleSocketMessage('report', message));
    useTypedSocket(Channel.SCHEDULE, ScheduleMessageC, (message) => handleSocketMessage('schedule', message));
};
